module.exports = __webpack_public_path__ + "img/logo.88018f0c.svg";